import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { eamApi } from "@/api/eamApi";
import { REM_CONFIG } from "@/utils/fontSize";
const AssetTrends = ({ className = "" }) => {
    const chartRef = useRef(null);
    const containerRef = useRef(null);
    const [dataSource, setDataSource] = useState([]);
    const mouthMark = dataSource.map((item) => item.mouthMark) || [];
    const totalValue = dataSource.map((item) => item.totalValue) || [];
    const totalCount = dataSource.map((item) => item.totalCount) || [];
    // 计算数据最小值
    const minValue = Math.min(...totalValue);
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await eamApi.month();
            // setDataSource(res.data as any);
            setDataSource([
                {
                    mouthMark: "2025-08",
                    totalValue: 191105343.07,
                    totalCount: 16,
                },
                {
                    mouthMark: "2025-09",
                    totalValue: 200738065.93,
                    totalCount: 22,
                },
                {
                    mouthMark: "2025-10",
                    totalValue: 211838060.93,
                    totalCount: 43,
                },
                {
                    mouthMark: "2025-10",
                    totalValue: 232738065.93,
                    totalCount: 87,
                },
                {
                    mouthMark: "2025-11",
                    totalValue: 244840895.74,
                    totalCount: 99,
                },
                {
                    mouthMark: "2025-12",
                    totalValue: 250408950.74,
                    totalCount: 110,
                },
                {
                    mouthMark: "2026-01",
                    totalValue: 258408950.74,
                    totalCount: 120,
                },
            ]);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    // ECharts配置：阴影从最小值刻度线向上填充
    const getEchartsOption = () => ({
        backgroundColor: "transparent",
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        legend: {
            data: ["金额（万元）"],
            show: false,
            textStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
            top: 10,
            left: "center",
        },
        xAxis: {
            type: "category",
            data: mouthMark,
            axisLabel: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
            axisTick: { show: false },
        },
        yAxis: [
            {
                type: "value",
                name: "金额（万元）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                    textShadowBlur: 2, // 模糊程度
                    // textShadowColor: "rgba(0,0,0,0.3)", // 文字阴影颜色
                },
                axisLabel: {
                    color: "#FFFFFF",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: (value) => {
                        return (value / 10000);
                    },
                },
                axisTick: { show: false },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 网格线浅灰透明
                },
                // 设置Y轴最小值为数据最小值，确保刻度线与最小值对齐
                min: 0,
                position: "left",
            },
        ],
        series: [
            // 主折线系列
            {
                name: "金额（元）",
                type: "line",
                data: totalValue,
                // 阴影从折线向下填充到最小值刻度线
                areaStyle: {
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: "rgba(23, 85, 112, 0.9)" }, // 折线处颜色
                            { offset: 1, color: "rgba(23, 85, 112, 0.3)" }, // 最小值处颜色
                        ],
                    },
                },
                // 折线样式
                lineStyle: {
                    color: "#44f0ff",
                    width: 2.5,
                },
                // 数据点样式
                itemStyle: {
                    color: "#44f0ff",
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                symbol: "circle",
                symbolSize: 8,
                smooth: false,
            },
            // 最小值参考线（明确标记阴影底部边界）
            {
                type: "line",
                data: totalCount,
                lineStyle: {
                    color: "rgba(255, 255, 255, 0.5)",
                    width: 1.5,
                    type: "dashed",
                },
                symbol: "none",
                showInLegend: false,
            },
        ],
        grid: {
            left: "5%",
            right: "5%",
            bottom: "10",
            top: "20%",
            containLabel: true,
        },
    });
    return (_jsxs("div", { ref: containerRef, className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]  /* 底部颜色带50%透明度 */
        to-[rgba(6,32,66,0.5)]    /* 顶部颜色带50%透明度 */
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u8D44\u4EA7\u8D8B\u52BF" }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { ref: chartRef, option: getEchartsOption(), style: { width: "100%", height: "100%" } }) })] }));
};
export default AssetTrends;
